module.exports = __webpack_public_path__ + "img/reaction.440c2265.png";